import React, {Component} from 'react'
import styled from '@emotion/styled'
import StyleVariales from '../../../../styles/styles'

// STYLE ##########################################################

const sv = StyleVariales;

const ItemContainer = styled(`div`)`
  ${sv.box};
  height: 100%;
  // border: 1px solid red;
  position: relative;
`;

const StyledGistItem = styled(`div`)`
  ${sv.box};
  margin-top: ${props => props.top}px;
  margin-left: ${props => props.left}px;
  transition: all ease-out 0.1s;
  text-transform: capitalize;
  font-size: ${props => props.fontSize}px;
  font-weight: ${props => props.fontWeight};
  color: ${props => props.fontColor};
`;

const StyledWord = styled(`div`)`
  margin-left: ${props => props.hasSecondary
    ? ( ((props.secondaryText.length > 3)
            ? (props.fontSize / 1.5)
            : (props.secondaryText.length * props.fontSize / 6.0)
    ) + "px")
    : "0" };
  margin-top: ${props => props.hasSecondary ? ((props.fontSize / -5.0 + 3.5) + "px") : "0" };
  font-size: ${props => props.fontSize}px;
  font-weight: ${props => props.fontWeight};
  color: ${props => props.fontColor};
  line-height: 100%;
`;


// COMPONENT ##########################################################

class CloudItem extends Component {

  render() {

    const {item} = {...this.props};

    const isTierOne = item.tier === 1;

      let textContent;
      let words = item.name.split(" ");
      if (words.length > 1) {
          let firstWords = words.slice(0, -1).join(" ");
          textContent = [
              <StyledWord
                  key="secondary"
                  fontSize={item.secondaryFont.size}
                  fontWeight={item.secondaryFont.weight}
                  fontColor={item.secondaryFont.color}
              >{firstWords}</StyledWord>,
              <StyledWord
                  key="primary"
                  fontSize={item.font.size}
                  fontWeight={item.font.weight}
                  fontColor={item.font.color}
                  hasSecondary={true}
                  secondaryText={firstWords}
              >{words[words.length - 1]}</StyledWord>
          ];
      } else {
          textContent = <StyledWord
              fontSize={item.font.size}
              fontWeight={item.font.weight}
              fontColor={item.font.color}
          >{words[0]}</StyledWord>
      }

    return (
      <ItemContainer>
        <StyledGistItem
          ref={(elm => this.itemElm = elm)}
          isTierOne={isTierOne}
          left={item.padding.left}
          top={item.padding.top}
          tier={item.tier}
          fontSize={item.font.size}
          fontWeight={item.font.weight}
          fontColor={item.font.color}
        >
          {textContent}
        </StyledGistItem>
      </ItemContainer>
    )
  }
}

export default CloudItem
